import { createApi } from "@reduxjs/toolkit/query/react";
import endpoints, { baseURL } from "data/api/v1/endpoints.ts";
import { APIErrorResponse, baseQueryWithRedirect, UntransformedResponse } from "features/api/utils/apiUtils.ts";
import { GetLaunchesRequest, GetLaunchesResponse, GetLaunchesResponseData } from "types/api/launches/getLaunches.ts";

export const launchApiSlice = createApi({
	reducerPath: "launchApi",
	baseQuery: baseQueryWithRedirect(baseURL),
	endpoints: (builder) => ({
		getLaunches: builder.query<GetLaunchesResponseData | undefined, GetLaunchesRequest>({
			query: (request) => ({
				url: endpoints.launches.getLaunches(),
				method: "POST",
				dataType: "json",
				headers: {
					"Content-type": "application/json; charset=UTF-8"
				},
				body: request
			}),
			transformResponse: (response: GetLaunchesResponse) => response?.data ?? undefined,
			transformErrorResponse: (error: UntransformedResponse<APIErrorResponse>) => ({
				status: error?.status
			})
		})
	})
});

export const { useGetLaunchesQuery } = launchApiSlice;
